﻿import { IBillableNephrectomy } from './billable-nephrectomy';

export interface IBillingDetail {
    isSbs: boolean;
    isGlobal: boolean;
    isMedicaid: boolean;
    isMedicare: boolean;
    donorId: number;
    isBillSent: boolean;
    claimType: string;
    swapNumber: string;
    asaUnits: number;
    asaUnitPrice: number;
    billableNephrectomy: IBillableNephrectomy;
    physicianCharges: number;
    anesthesiaCharges: number;
    hospitalCharges: number;
    physicianChargesFile: string;
    anesthesiaChargesFile: string;
    hospitalChargesFile: string;
    centerRoutingNumber: string;
    centerAccountNumber: string;
    centerW9File: string;
    acceptRejectDeadline: string;
    dateSubmittedToRecipientCenter: string;
    dateAcceptedByRecipientCenter: string;
    dateDisputedByRecipientCenter: string;
    ctrInvoiceDaysToRemit: number;
    disputedBy: string;
    billedBy: string;
    invoiceDate: string;
    isDonorCenter: boolean;
    remitDays: number;
    achSaved: boolean;
    ccbPayableDays: number;
    hasLate: boolean;
    hasOutstandingDelinquency: boolean;
}
